<script>
  export let currentRoute
</script>

<h1>Show team {currentRoute.namedParams.id}</h1>
